import Length from "./Length";
import Rectangle from "./Rectangle";

export default class AbstractShape {
	static DEFAULT_MATERIAL_LOSS = 20;

	/**
	 * @return {string} The name of the shape.
	 */
	get_name() {
		throw new Error( 'Method `get_name()` must be implemented' );
	}

	/**
	 * @return {Rectangle} The enclosing rectangle.
	 */
	get_enclosing_rectangle() {
		throw new Error( 'Method `get_enclosing_rectangle()` must be implemented' );
	}

	get_required_material() {
		const enclosing_rect = this.get_enclosing_rectangle();
		const length         = enclosing_rect.get_length().add( new Length( this.get_material_loss() ) );
		const width          = enclosing_rect.get_width().add( new Length( this.get_material_loss() ) );

		return new Rectangle( length, width );
	}

	/**
	 * @return {Area} The area of the shape.
	 */
	get_area() {
		throw new Error( 'Method `get_area()` must be implemented' );
	}

	/**
	 * @return {Length} The circumference of the shape.
	 */
	get_circumference() {
		throw new Error( 'Method `get_circumference()` must be implemented' );
	}

	get_material_loss() {
		const pricingGroup = window.measurementSelectorVariables.pricingGroup.other_settings;

		if ( ! ( 'material_loss' in pricingGroup ) ) {
			return AbstractShape.DEFAULT_MATERIAL_LOSS;
		}

		return pricingGroup[ 'material_loss' ] !== '' ? pricingGroup[ 'material_loss' ] * 2 : AbstractShape.DEFAULT_MATERIAL_LOSS;
	}

	/**
	 * @return {any[]} The primitives of the shape.
	 */
	serialize_primitives() {
		throw new Error( 'Method `serialize_primitives()` must be implemented' );
	}

	static deserialize_primitives() {
		throw new Error( 'Method `deserialize_primitives()` must be implemented' );
	}
}
